import React from "react";
import { PageHeader, PrimaryButton } from "../components/Shared";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useLang } from "../context/LanguageContext";

const FAQPage = () => {
  const { t } = useLang();
  const { FAQS, UI } = t;

  return (
    <div>
      <PageHeader eyebrow={FAQS.eyebrow} title={FAQS.title} subtitle={FAQS.subtitle} />

      <section className="bg-white py-14 md:py-16">
        <div className="mx-auto max-w-3xl px-6">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.items.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={item.q}
                className="rounded-2xl border border-slate-200 bg-white px-6 data-[state=open]:shadow-md"
              >
                <AccordionTrigger data-testid={`faq-question-${i}`} className="py-5 text-left text-[16px] font-semibold text-slate-900 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="pb-6 text-[15px] leading-relaxed text-slate-600">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-14 rounded-2xl bg-slate-900 px-8 py-10 text-center">
            <h2 className="text-2xl font-bold text-white">{UI.faq.stillTitle}</h2>
            <p className="mt-3 text-slate-300">{UI.faq.stillText}</p>
            <div className="mt-7">
              <PrimaryButton to="/book-demo" data-testid="faq-book-demo" className="!bg-white !text-slate-900 hover:!bg-slate-100">
                {UI.faq.stillCta}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
